import { ActionEvents } from '@griply/types';
import { taskTypeToTrackingTaskType } from '@griply/utils';
import { useCallback } from 'react';
import { useCreateSubTaskMutation } from 'shared/hooks/queries/use-create-sub-task-mutation';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';
import { TaskType } from 'shared/types/task-base';

export type Options = {
  parentId: ID;
  parentParentIds: ID[] | null;
  parentChildIds: ID[] | null;
};

export const useCreateSubTask = ({
  parentId,
  parentParentIds,
  parentChildIds,
}: Options) => {
  const track = useTrackEvents();
  const { mutateAsync: createSubTask } = useCreateSubTaskMutation();

  const submit = useCallback(
    async (name: string): Promise<Task | null> => {
      const result = await createSubTask({
        name,
        parentId,
        parentParentIds,
        parentChildIds,
      });

      if (!result) {
        return null;
      }

      track(ActionEvents.TaskCreate, {
        type: taskTypeToTrackingTaskType[TaskType.Task],
        deadline_added: false,
        linked_goal: false,
      });

      return {
        id: result.id,
        name: result.name,
        type: TaskType.Task,
        parentIds: result.parentIds,
        createdAt: new Date(),
        goalId: null,
        lifeAreaId: null,
        reminderTime: null,
        startDate: null,
        priority: null,
        endStrategy: null,
        schedules: null,
        hideOnTodo: null,
      } as unknown as Task;
    },
    [createSubTask, parentId, parentParentIds, parentChildIds, track],
  );

  return { submit };
};
